const common = {
  nav: {
    categories: "Kategorien",
    guides: "Leitfäden",
    shipping: "Versand",
    qc: "Qualitätskontrolle",
    reviews: "Bewertungen",
    comparisons: "Vergleiche",
    safety: "Sicherheit",
    contact: "Kontakt",
    about: "Über uns",
    products: "Produkte",
  },
  languages: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
  hero: {
    h1: "AllChinaBuy Spreadsheet — Produkte, Funde & Kaufressourcen entdecken",
    subtitle: "Entdecken Sie die neuesten AllChinaBuy Spreadsheet-Ressourcen, Produktfunde, Kaufleitfäden, Versandinformationen, QC-Tipps und vertrauenswürdige Ressourcen — alles an einem Ort organisiert.",
    primaryCta: "AllChinaBuy Spreadsheet erkunden",
    secondaryCta: "Kaufleitfäden durchsuchen",
    trustText: "Unabhängige Ressource • Mehrsprachige Leitfäden • Aktualisierter Inhalt",
    mainCta: "Hauptwebsite besuchen",
  },
  categories: {
    title: "Shopping-Kategorien",
    shoes: "Schuhe",
    hoodies: "Hoodies/Pullover",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen/Shorts",
    headwear: "Kopfbedeckungen",
    sets: "Sets",
    underwear: "Unterwäsche/Unterhosen",
    jersey: "Trikots",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfums",
    other: "Sonstiges",
  },
  whatIs: {
    h2: "Was ist das AllChinaBuy Spreadsheet?",
    description: "Das AllChinaBuy Spreadsheet ist eine praktische Möglichkeit, organisierte Produktressourcen, Produktlinks, Kategorien und Kaufinformationen zu entdecken. Anstatt über mehrere Quellen zu suchen, nutzen Sie unsere Ressourcen-Hub, um AllChinaBuy-bezogene Produkte, Leitfäden und praktische Kaufinformationen an einem Ort zu erkunden.",
    cta: "Spreadsheet erkunden",
  },
  resources: {
    h2: "Beliebte AllChinaBuy-Ressourcen erkunden",
    spreadsheet: "AllChinaBuy Spreadsheet",
    finds: "AllChinaBuy Funde",
    products: "AllChinaBuy Produkte",
    shippingResource: "AllChinaBuy Versand",
    qcResource: "AllChinaBuy QC",
    warehouse: "AllChinaBuy Lager",
    review: "AllChinaBuy Bewertung",
    coupon: "AllChinaBuy Gutschein",
  },
  guides: {
    h2: "AllChinaBuy Kaufleitfäden",
    reviewGuide: "AllChinaBuy Bewertung",
    shippingCost: "Versandkosten-Leitfaden",
    warehouseGuide: "Lagerleitfaden",
    qcGuide: "QC-Leitfaden",
    safetyGuide: "Sicherheitsleitfaden",
    couponGuide: "Gutscheinleitfaden",
  },
  latestFinds: {
    h2: "Neueste AllChinaBuy-Funde",
    cta: "AllChinaBuy-Funde erkunden",
  },
  shipping: {
    h2: "AllChinaBuy Versand, QC & Lagerinformationen",
    description: "Verstehen Sie AllChinaBuy-Versandoptionen, Lagerprozesse und Qualitätskontrollüberlegungen, bevor Sie Ihre Bestellung aufgeben. Unsere Leitfäden decken Versandmethoden, potenzielle Kosten, Tracking und Risikomanagement-Tipps ab.",
  },
  comparison: {
    h2: "AllChinaBuy Vergleiche",
    description: "Vergleichen Sie AllChinaBuy mit anderen beliebten Einkaufsagenten, um eine fundierte Entscheidung über Ihr Kauferlebnis zu treffen.",
  },
  safety: {
    h2: "Ist AllChinaBuy legitim und sicher?",
    description: "Wir bieten neutrale, evidenzbasierte Anleitungen zu AllChinaBuy-Sicherheit, Legitimität und Risikofaktoren. Unser Sicherheitsleitfaden deckt Zahlungssicherheit, Verkäuferverifizierung und Käuferschutz-Tipps ab.",
    cta: "AllChinaBuy-Sicherheitsleitfaden lesen",
  },
  whyUs: {
    h2: "Warum unser AllChinaBuy Spreadsheet-Hub nutzen?",
    organized: "Organisierte Ressourcen",
    organizedDesc: "Alle Produktlinks, Kategorien und Leitfäden an einem praktischen Ort.",
    discovery: "Einfache Produktsuche",
    discoveryDesc: "Finden Sie schnell, was Sie brauchen, ohne auf mehreren Websites zu suchen.",
    practical: "Praktische Leitfäden",
    practicalDesc: "Schritt-für-Schritt-Kaufleitfäden, Versandtipps und QC-Ratschläge.",
    shippingInfo: "Versandinformationen",
    shippingInfoDesc: "Verstehen Sie Versandmethoden, Kosten und Zeitpläne, bevor Sie kaufen.",
    multilingual: "Mehrsprachiger Inhalt",
    multilingualDesc: "Greifen Sie auf Leitfäden in Englisch, Französisch, Dänisch und Deutsch zu.",
    updated: "Regelmäßige Updates",
    updatedDesc: "Unser Inhalt wird regelmäßig aktualisiert, um die neuesten Informationen widerzuspiegeln.",
  },
  bottomCta: {
    h2: "AllChinaBuy entdecken",
    primaryCta: "AllChinaBuy Spreadsheet erkunden",
    secondaryCta: "Hauptwebsite besuchen",
    description: "Erkunden Sie das komplette AllChinaBuy-Spreadsheet, stöbern Sie in kuratierten Produktfunden und greifen Sie auf detaillierte Kaufleitfäden in Ihrer bevorzugten Sprache zu.",
  },
  articles: {
    h2: "AllChinaBuy Spreadsheet-Artikel",
    readMore: "Artikel lesen",
  },
  footer: {
    disclaimer: "Haftungsausschluss: Dies ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website. AllChinaBuy ist eine Marke der jeweiligen Eigentümer.",
    spreadsheet: "AllChinaBuy Spreadsheet",
    resources: "Ressourcen",
    categories: "Kategorien",
    guides: "Leitfäden",
    reviews: "Bewertungen",
    shipping: "Versand",
    warehouse: "Lager",
    qc: "QC",
    comparisons: "Vergleiche",
    safety: "Sicherheit",
    about: "Über uns",
    contact: "Kontakt",
    privacy: "Datenschutzrichtlinie",
    terms: "Nutzungsbedingungen",
    editorial: "Redaktionelle Richtlinien",
    language: "Sprache",
    copyright: "© 2026 AllChinaBuy Spreadsheet Hub. Alle Rechte vorbehalten.",
  },
  common: {
    readMore: "Mehr lesen",
    learnMore: "Mehr erfahren",
    explore: "Erkunden",
    view: "Ansehen",
    updated: "Aktualisiert",
  },
  allChinaBuy: {
    title: "AllChinaBuy Spreadsheet",
    buyNow: "Jetzt kaufen",
  },

  products: {
    title: "Alle Produkte",
    description: "Durchsuchen Sie unsere kuratierte Sammlung von AllChinaBuy-Produkten. Klicken Sie auf einen Artikel, um die Produktseite zu besuchen und über kaspreadsheet.com zu kaufen.",
    disclaimer: "Dies ist eine unabhängige Ressource. Produkte verlinken zu kaspreadsheet.com zum Kauf.",
    filterAll: "Alle Kategorien",
    searchPlaceholder: "Produkte suchen...",
    productCount: "{{count}} Produkt",
    productCount_plural: "{{count}} Produkte",
    noResults: "Keine Produkte gefunden",
    noResultsDesc: "Versuchen Sie, Ihre Suche oder Ihren Kategoriefilter anzupassen",
    clearFilters: "Filter löschen",
    buyNow: "Jetzt kaufen",
    buy: "Kaufen",
    viewAll: "Alle Produkte ansehen",
    moreProducts: "Suchen Sie nach mehr Produkten?",
    moreProductsDesc: "Besuchen Sie die Hauptwebsite kaspreadsheet.com für den vollständigen Katalog mit Tausenden weiteren Produkten.",
  },
  meta: {
    siteTitle: "AllChinaBuy Spreadsheet Hub — Produktfunde & Kaufleitfäden",
    description: "Ihre unabhängige Ressourcen-Hub für AllChinaBuy Spreadsheet-Ressourcen, Produktfunde, Kaufleitfäden, Versandinformationen und QC-Tipps. Erkunden Sie organisierte Kategorien und Leitfäden in mehreren Sprachen.",
  },

  article: {
    home: "Startseite",
    lastUpdated: "Zuletzt aktualisiert",
    disclaimer: "Haftungsausschluss",
    disclaimerText: "Dies ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website. Alle bereitgestellten Informationen dienen ausschließlich Bildungszwecken. Überprüfen Sie vor dem Kauf immer Details direkt bei den Verkäufern.",
    faqTitle: "Häufig gestellte Fragen",
    readyToExplore: "Bereit zum Entdecken?",
    ctaDesc: "Besuchen Sie die Hauptwebsite von AllChinaBuy, um den vollständigen Produktkatalog zu durchsuchen und mit dem Einkauf zu beginnen.",
    relatedArticles: "Verwandte Artikel",
    backToHome: "Zurück zur Startseite",
    ctaText: "Weiter zur Hauptwebsite",
  },
};

export default common;